// extracted by mini-css-extract-plugin
export var desctiption = "MasonryGrid-module--desctiption--IUMCp";
export var myMasonryGrid = "MasonryGrid-module--myMasonryGrid--dQP7F";
export var myMasonryGrid_column = "MasonryGrid-module--myMasonryGrid_column--aJmN0";